import React from "react";

export const UserIcon = (color = "current") => {
	return (
		<svg
			width="29"
			height="25"
			viewBox="0 0 29 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M0 5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0H23C24.3261 0 25.5979 0.526784 26.5355 1.46447C27.4732 2.40215 28 3.67392 28 5V6.5H26V5C26 4.20435 25.6839 3.44129 25.1213 2.87868C24.5587 2.31607 23.7956 2 23 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V15C2 15.7956 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H12.06C12.02 18.244 12 18.494 12 18.752C12 19.176 12.04 19.594 12.114 20H5C3.67392 20 2.40215 19.4732 1.46447 18.5355C0.526784 17.5979 0 16.3261 0 15V5Z"
				fill={color}
			/>
			<path
				d="M26.75 24C26.75 24 28.1667 24 28.1667 22.5833C28.1667 21.1667 26.75 16.9167 21.0833 16.9167C15.4167 16.9167 14 21.1667 14 22.5833C14 24 15.4167 24 15.4167 24H26.75ZM15.4478 22.5833C15.4374 22.5819 15.427 22.58 15.4167 22.5777C15.4181 22.2037 15.6533 21.1185 16.4933 20.141C17.2753 19.2244 18.6495 18.3333 21.0833 18.3333C23.5158 18.3333 24.8899 19.2258 25.6733 20.141C26.5134 21.1185 26.7472 22.2051 26.75 22.5777L26.7387 22.5805C26.7321 22.5816 26.7255 22.5826 26.7188 22.5833H15.4478ZM21.0833 14.0833C21.8348 14.0833 22.5554 13.7848 23.0868 13.2535C23.6182 12.7221 23.9167 12.0014 23.9167 11.25C23.9167 10.4986 23.6182 9.77788 23.0868 9.24653C22.5554 8.71518 21.8348 8.41667 21.0833 8.41667C20.3319 8.41667 19.6112 8.71518 19.0799 9.24653C18.5485 9.77788 18.25 10.4986 18.25 11.25C18.25 12.0014 18.5485 12.7221 19.0799 13.2535C19.6112 13.7848 20.3319 14.0833 21.0833 14.0833ZM25.3333 11.25C25.3333 11.8081 25.2234 12.3608 25.0098 12.8764C24.7962 13.392 24.4832 13.8606 24.0885 14.2552C23.6939 14.6499 23.2254 14.9629 22.7097 15.1765C22.1941 15.3901 21.6415 15.5 21.0833 15.5C20.5252 15.5 19.9726 15.3901 19.4569 15.1765C18.9413 14.9629 18.4728 14.6499 18.0781 14.2552C17.6835 13.8606 17.3704 13.392 17.1568 12.8764C16.9433 12.3608 16.8333 11.8081 16.8333 11.25C16.8333 10.1228 17.2811 9.04183 18.0781 8.2448C18.8752 7.44777 19.9562 7 21.0833 7C22.2105 7 23.2915 7.44777 24.0885 8.2448C24.8856 9.04183 25.3333 10.1228 25.3333 11.25Z"
				fill={color}
			/>
			<path
				fill={color}
				d="M 5,3.25 C 4.0433477,3.25 3.25,4.0433477 3.25,5 v 4 c 0,0.9566523 0.7933477,1.75 1.75,1.75 h 6 c 0.956652,0 1.75,-0.7933477 1.75,-1.75 V 5 C 12.75,4.0433477 11.956652,3.25 11,3.25 Z m 0,1.5 h 6 c 0.151347,0 0.25,0.098653 0.25,0.25 v 4 c 0,0.1513466 -0.09865,0.25 -0.25,0.25 H 5 C 4.8486534,9.25 4.75,9.1513466 4.75,9 V 5 C 4.75,4.8486534 4.8486534,4.75 5,4.75 Z"
			/>
		</svg>
	);
};

export const ProjectIcon = (color = "current") => {
	return (
		<svg
			width="26"
			height="24"
			viewBox="0 0 26 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.98352 0.00199326C3.66181 0.00199326 2.39423 0.527041 1.45964 1.46163C0.525048 2.39622 0 3.6638 0 4.98552V16.946C0 18.2677 0.525048 19.5353 1.45964 20.4699C2.39423 21.4044 3.66181 21.9295 4.98352 21.9295H13.5173C13.5831 21.4989 13.7266 21.0723 13.9578 20.6736L14.3844 19.9361H4.98352C4.19049 19.9361 3.42995 19.621 2.86919 19.0603C2.30844 18.4995 1.99341 17.739 1.99341 16.946V5.98023H19.9341V8.36036C20.5696 8.10907 21.2443 7.97143 21.9275 7.9537V4.98352C21.9275 3.66181 21.4024 2.39423 20.4679 1.45964C19.5333 0.525048 18.2657 0 16.944 0H4.98352V0.00199326ZM2.16086 3.98682C2.36706 3.40359 2.74907 2.89867 3.25426 2.54165C3.75944 2.18463 4.36292 1.99308 4.98153 1.99341H16.942C17.5602 1.9935 18.1633 2.18524 18.6681 2.54223C19.1729 2.89922 19.5546 3.40391 19.7607 3.98682H2.16086Z"
				fill={color}
			/>
			<path
				d="M16.7765 11.3823L13.6628 8.26465C13.4749 8.08309 13.2231 7.98263 12.9618 7.9849C12.7004 7.98717 12.4504 8.09199 12.2656 8.27679C12.0808 8.46159 11.976 8.71157 11.9738 8.97291C11.9715 9.23424 12.0719 9.48601 12.2535 9.67399L15.5347 12.9571L12.2535 16.2383C12.1583 16.3302 12.0824 16.4402 12.0301 16.5618C11.9779 16.6834 11.9504 16.8142 11.9493 16.9465C11.9481 17.0789 11.9733 17.2101 12.0234 17.3326C12.0736 17.4551 12.1476 17.5664 12.2411 17.66C12.3347 17.7536 12.446 17.8276 12.5685 17.8777C12.691 17.9278 12.8222 17.953 12.9546 17.9519C13.0869 17.9507 13.2177 17.9232 13.3393 17.871C13.4609 17.8188 13.5709 17.7428 13.6628 17.6476L16.3898 14.9206C16.1423 13.7286 16.2776 12.4889 16.7765 11.3784V11.3823Z"
				fill={color}
			/>
			<path
				d="M9.67406 8.26643C9.86092 8.45334 9.96589 8.70681 9.96589 8.9711C9.96589 9.23539 9.86092 9.48886 9.67406 9.67577L6.39291 12.9589L9.67406 16.2401C9.76926 16.332 9.84519 16.442 9.89743 16.5636C9.94966 16.6852 9.97716 16.816 9.97831 16.9483C9.97946 17.0807 9.95424 17.2119 9.90412 17.3344C9.85401 17.4569 9.78 17.5682 9.68642 17.6618C9.59283 17.7553 9.48155 17.8294 9.35906 17.8795C9.23657 17.9296 9.10532 17.9548 8.97298 17.9537C8.84064 17.9525 8.70985 17.925 8.58825 17.8728C8.46665 17.8205 8.35667 17.7446 8.26472 17.6494L4.27791 13.6626C4.09105 13.4757 3.98608 13.2222 3.98608 12.9579C3.98608 12.6936 4.09105 12.4402 4.27791 12.2532L8.26472 8.26643C8.45163 8.07958 8.7051 7.97461 8.96939 7.97461C9.23368 7.97461 9.48715 8.07958 9.67406 8.26643Z"
				fill={color}
			/>
			<path
				d="M20.9726 13.1168L22.7667 10.0071C22.0193 9.86739 21.2472 9.95467 20.5499 10.2577C19.8526 10.5606 19.262 11.0655 18.8541 11.7071C18.4462 12.3487 18.2398 13.0978 18.2613 13.8578C18.2829 14.6178 18.5316 15.3539 18.9752 15.9713L15.6841 21.6725C15.4924 22.0355 15.4489 22.4587 15.5627 22.8532C15.6765 23.2477 15.9387 23.5827 16.2943 23.7878C16.6499 23.993 17.0712 24.0523 17.4696 23.9534C17.8681 23.8544 18.2127 23.6049 18.431 23.2572L21.7301 17.5461C22.4841 17.6142 23.2412 17.4559 23.9048 17.0916C24.5684 16.7272 25.1084 16.1733 25.4556 15.5006C25.8029 14.8279 25.9417 14.067 25.8544 13.315C25.7671 12.563 25.4576 11.8541 24.9654 11.2789L23.1713 14.3866C23.0899 14.5346 22.9797 14.6649 22.8473 14.7698C22.7148 14.8748 22.5627 14.9522 22.4 14.9976C22.2372 15.043 22.0671 15.0554 21.8994 15.0342C21.7318 15.013 21.5701 14.9586 21.4238 14.8741C21.2774 14.7896 21.1495 14.6767 21.0473 14.5421C20.9452 14.4075 20.8709 14.2539 20.8289 14.0902C20.7869 13.9266 20.7779 13.7562 20.8026 13.589C20.8273 13.4219 20.8851 13.2613 20.9726 13.1168Z"
				fill={color}
			/>
		</svg>
	);
};

export const ClientIcon = (color = "current") => {
	return (
		<svg
			width="18"
			height="22"
			viewBox="0 0 18 22"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.8886 11.0113C11.7303 11.0113 14.0303 8.71134 14.0303 5.86967C14.0303 3.02799 11.7303 0.728027 8.8886 0.728027C6.047 0.728027 3.747 3.02799 3.747 5.86967C3.747 8.71134 6.047 11.0113 8.8886 11.0113ZM12.4143 12.4803H12.0333C11.0784 12.9394 10.018 13.2149 8.8886 13.2149C7.7593 13.2149 6.7034 12.9394 5.744 12.4803H5.3629C2.44323 12.4803 0.0744019 14.8492 0.0744019 17.7689V19.091C0.0744019 20.3076 1.06141 21.2946 2.27796 21.2946H15.4993C16.7159 21.2946 17.7029 20.3076 17.7029 19.091V17.7689C17.7029 14.8492 15.3341 12.4803 12.4143 12.4803Z"
				fill={color}
			/>
		</svg>
	);
};

export const ReportIcon = (color = "current") => {
	return (
		<svg
			width="22"
			height="28"
			viewBox="0 0 22 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M 4.6660156,0.875 C 3.6608345,0.875 2.697096,1.2755602 1.9863281,1.9863281 1.2755602,2.697096 0.875,3.6608345 0.875,4.6660156 V 23.333984 c 0,1.00521 0.4005443,1.968904 1.1113281,2.679688 C 2.6970608,26.724262 3.6607815,27.125 4.6660156,27.125 H 18 c 1.005205,0 1.970892,-0.400722 2.681641,-1.111328 0.710757,-0.710757 1.109375,-1.674425 1.109375,-2.679688 v -12.78125 a 1.1251125,1.1251125 0 0 0 0,-0.002 C 21.790831,9.8993791 21.533111,9.2750962 21.072266,8.8144531 l -7.21875,-7.21875 C 13.392984,1.1350426 12.76672,0.87514739 12.115234,0.875 Z m 0,2.25 h 7.4492184 c 0.05571,1.26e-5 0.107017,0.021068 0.146485,0.060547 l 7.21875,7.2187501 c 0.03935,0.03934 0.06053,0.09264 0.06055,0.148437 v 12.78125 c 0,0.409336 -0.161731,0.800402 -0.451172,1.089844 C 18.800393,24.713221 18.409193,24.875 18,24.875 H 4.6660156 C 4.2567512,24.875 3.8656382,24.713237 3.5761719,24.423828 3.2867567,24.134413 3.125,23.743373 3.125,23.333984 V 4.6660156 C 3.125,4.2566982 3.2867408,3.865603 3.5761719,3.5761719 3.865603,3.2867408 4.2566982,3.125 4.6660156,3.125 Z m 10.6679684,8.431641 a 1.1251125,1.1251125 0 0 0 -1.125,1.109375 v 8 a 1.1251125,1.1251125 0 0 0 2.25,0 v -8 a 1.1251125,1.1251125 0 0 0 -1.125,-1.109375 z m -4,2.667968 a 1.1251125,1.1251125 0 0 0 -1.125,1.109375 v 5.332032 a 1.1251125,1.1251125 0 0 0 1.125,1.109375 1.1251125,1.1251125 0 0 0 1.125,-1.109375 v -5.332032 a 1.1251125,1.1251125 0 0 0 -1.125,-1.109375 z M 7.3339844,16.890625 A 1.1251125,1.1251125 0 0 0 6.2089844,18 v 2.666016 a 1.1251125,1.1251125 0 0 0 2.25,0 V 18 a 1.1251125,1.1251125 0 0 0 -1.125,-1.109375 z"
				fill={color}
			/>
		</svg>
	);
};

export const NewsIcon = (color = "current") => {
	return (
		<svg
			width="31"
			height="24"
			viewBox="0 0 31 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.45455 6.54545C5.16522 6.54545 4.88774 6.66039 4.68316 6.86497C4.47857 7.06956 4.36364 7.34704 4.36364 7.63636C4.36364 7.92569 4.47857 8.20317 4.68316 8.40775C4.88774 8.61234 5.16522 8.72727 5.45455 8.72727H20.7273C21.0166 8.72727 21.2941 8.61234 21.4987 8.40775C21.7032 8.20317 21.8182 7.92569 21.8182 7.63636C21.8182 7.34704 21.7032 7.06956 21.4987 6.86497C21.2941 6.66039 21.0166 6.54545 20.7273 6.54545H5.45455ZM5.45455 10.9091C5.16522 10.9091 4.88774 11.024 4.68316 11.2286C4.47857 11.4332 4.36364 11.7107 4.36364 12V16.3636C4.36364 16.653 4.47857 16.9304 4.68316 17.135C4.88774 17.3396 5.16522 17.4545 5.45455 17.4545H9.81818C10.1075 17.4545 10.385 17.3396 10.5896 17.135C10.7942 16.9304 10.9091 16.653 10.9091 16.3636V12C10.9091 11.7107 10.7942 11.4332 10.5896 11.2286C10.385 11.024 10.1075 10.9091 9.81818 10.9091H5.45455ZM6.54545 15.2727V13.0909H8.72727V15.2727H6.54545ZM14.1818 10.9091C13.8925 10.9091 13.615 11.024 13.4104 11.2286C13.2058 11.4332 13.0909 11.7107 13.0909 12C13.0909 12.2893 13.2058 12.5668 13.4104 12.7714C13.615 12.976 13.8925 13.0909 14.1818 13.0909H20.7273C21.0166 13.0909 21.2941 12.976 21.4987 12.7714C21.7032 12.5668 21.8182 12.2893 21.8182 12C21.8182 11.7107 21.7032 11.4332 21.4987 11.2286C21.2941 11.024 21.0166 10.9091 20.7273 10.9091H14.1818ZM14.1818 15.2727C13.8925 15.2727 13.615 15.3877 13.4104 15.5922C13.2058 15.7968 13.0909 16.0743 13.0909 16.3636C13.0909 16.653 13.2058 16.9304 13.4104 17.135C13.615 17.3396 13.8925 17.4545 14.1818 17.4545H20.7273C21.0166 17.4545 21.2941 17.3396 21.4987 17.135C21.7032 16.9304 21.8182 16.653 21.8182 16.3636C21.8182 16.0743 21.7032 15.7968 21.4987 15.5922C21.2941 15.3877 21.0166 15.2727 20.7273 15.2727H14.1818ZM0 4.36364C0 3.20633 0.459739 2.09642 1.27808 1.27808C2.09642 0.459739 3.20633 0 4.36364 0H21.8182C22.9755 0 24.0854 0.459739 24.9037 1.27808C25.7221 2.09642 26.1818 3.20633 26.1818 4.36364C27.3391 4.36364 28.449 4.82338 29.2674 5.64172C30.0857 6.46006 30.5455 7.56996 30.5455 8.72727V18.5455C30.5455 19.9921 29.9708 21.3795 28.9479 22.4024C27.9249 23.4253 26.5375 24 25.0909 24H5.45455C4.00791 24 2.62053 23.4253 1.5976 22.4024C0.574674 21.3795 0 19.9921 0 18.5455V4.36364ZM25.0909 18.5455C24.8016 18.5455 24.5241 18.4305 24.3195 18.2259C24.1149 18.0214 24 17.7439 24 17.4545V4.36364C24 3.78498 23.7701 3.23003 23.361 2.82086C22.9518 2.41169 22.3968 2.18182 21.8182 2.18182H4.36364C3.78498 2.18182 3.23003 2.41169 2.82086 2.82086C2.41169 3.23003 2.18182 3.78498 2.18182 4.36364V18.5455C2.18182 19.4134 2.52662 20.2459 3.14038 20.8596C3.75413 21.4734 4.58656 21.8182 5.45455 21.8182H25.0909C25.9589 21.8182 26.7913 21.4734 27.4051 20.8596C28.0188 20.2459 28.3636 19.4134 28.3636 18.5455V8.72727C28.3636 8.14862 28.1338 7.59367 27.7246 7.18449C27.3154 6.77532 26.7605 6.54545 26.1818 6.54545V17.4545C26.1818 17.7439 26.0669 18.0214 25.8623 18.2259C25.6577 18.4305 25.3802 18.5455 25.0909 18.5455Z"
				fill={color}
			/>
		</svg>
	);
};

export const BenefitsIcon = (color = "current") => {
	return (
		<svg
			width="28"
			height="24"
			viewBox="0 0 28 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.02605 13.9436C8.79144 13.9575 8.65981 13.9916 8.61026 14.0132C8.11936 14.2378 6.50805 14.8224 5.42017 15.2119V20.7093C5.97766 20.6838 6.60484 20.6621 6.95714 20.676C8.52276 20.7388 9.70511 21.1035 10.81 21.4542L10.9076 21.4852C11.9746 21.8243 12.9703 22.141 14.2796 22.2401C14.6815 22.2711 15.0322 22.3059 15.3605 22.3392C15.7507 22.3824 16.1418 22.4157 16.5336 22.4391C17.1995 22.4732 17.7105 22.4368 18.124 22.285C18.635 22.0976 20.4779 21.2359 22.3284 20.2966C23.1828 19.8666 24.0275 19.4177 24.8619 18.9501C25.1676 18.7791 25.4685 18.5994 25.764 18.4112C26.0172 18.2463 26.1395 18.148 26.1728 18.1139C26.3106 17.9722 26.4089 17.5812 26.2285 17.2289C26.1031 16.9834 25.7531 16.6242 24.7698 16.7868C23.6316 16.9749 22.2781 17.5301 20.9486 18.0752C20.3036 18.34 19.6618 18.6025 19.0942 18.7922C18.5491 18.9741 17.9637 19.1282 17.462 19.098C16.7341 19.0539 15.4519 18.8619 14.388 18.6884C13.7776 18.5888 13.168 18.4846 12.5592 18.3756L12.4407 18.3547L12.3997 18.347L12.5383 17.5851L12.3989 18.347L12.5475 16.8108L16.6978 16.8611C16.7016 16.8611 16.707 16.8611 16.7148 16.8596C16.7427 16.8572 16.7984 16.8503 16.8789 16.8294C17.0369 16.7883 17.2971 16.6923 17.6192 16.4616C17.7307 16.3818 17.8669 16.2432 17.99 16.0636C18.0907 15.9165 18.1658 15.7686 18.2099 15.6431C17.5913 15.6253 16.9842 15.5216 16.5313 15.4225C16.2652 15.3642 16.0012 15.2966 15.74 15.2196L15.7043 15.2088L10.6203 14.0682H10.6188C10.538 14.0538 10.4569 14.0409 10.3756 14.0295C10.2115 14.0055 9.98618 13.9769 9.74228 13.9575C9.5041 13.9372 9.26484 13.9326 9.02605 13.9436V13.9436ZM10.7744 13.3086L10.9161 12.5483L10.93 12.5506L16.1085 13.712L16.1403 13.7229L16.1496 13.726L16.1852 13.7368L16.3307 13.7786C16.4585 13.8143 16.6428 13.8615 16.8619 13.9095C17.3063 14.0071 17.8669 14.0969 18.3904 14.0969C18.8735 14.0969 19.3729 14.2773 19.6401 14.7666C19.8693 15.1863 19.8158 15.6478 19.7299 15.9668C19.623 16.3648 19.4016 16.7829 19.1205 17.1383C19.4999 16.9951 19.9149 16.8255 20.3609 16.6427L20.4562 16.604C21.7129 16.0876 23.2026 15.4759 24.5166 15.2591C26.0187 15.0105 27.1112 15.5556 27.6068 16.5227C28.0481 17.3837 27.9459 18.5134 27.2816 19.194C27.1151 19.3652 26.8611 19.5448 26.6064 19.7097C26.2853 19.9152 25.9584 20.1114 25.6261 20.2982C24.7708 20.7773 23.9049 21.2373 23.0292 21.678C21.1933 22.6095 19.2684 23.5154 18.6567 23.7391C17.9475 23.9985 17.1856 24.0233 16.4539 23.9854C16.0122 23.9579 15.5713 23.9205 15.1314 23.8731C14.7984 23.8398 14.467 23.8073 14.1635 23.7841C12.6707 23.671 11.5247 23.3063 10.4701 22.971L10.3416 22.93C9.25215 22.5839 8.2386 22.2773 6.8952 22.2231C6.43836 22.2053 5.30248 22.2641 4.69078 22.2997L3.87158 22.3477V14.1193L4.38649 13.9366C5.43565 13.5634 7.46972 12.8317 7.9676 12.6048C8.27886 12.4631 8.63891 12.4151 8.93701 12.3973C9.24546 12.3823 9.55456 12.3877 9.86229 12.4136C10.2066 12.441 10.5495 12.4844 10.8898 12.5436L10.9084 12.5467L10.913 12.5475H10.9161L10.7744 13.3094V13.3086Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0 13.9373C0 13.5265 0.163154 13.1327 0.453571 12.8422C0.743987 12.5518 1.13788 12.3887 1.54859 12.3887H3.87147C4.28218 12.3887 4.67607 12.5518 4.96648 12.8422C5.2569 13.1327 5.42005 13.5265 5.42005 13.9373V22.4514C5.42005 22.8621 5.2569 23.256 4.96648 23.5464C4.67607 23.8368 4.28218 24 3.87147 24H1.54859C1.13788 24 0.743987 23.8368 0.453571 23.5464C0.163154 23.256 0 22.8621 0 22.4514V13.938V13.9373ZM1.54859 13.9373V22.4514H3.87147V13.938H1.54859V13.9373Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.3887 0C9.82295 0 7.74292 2.08003 7.74292 4.64576C7.74292 7.21149 9.82295 9.29152 12.3887 9.29152C14.9544 9.29152 17.0344 7.21149 17.0344 4.64576C17.0344 2.08003 14.9544 0 12.3887 0ZM12.811 6.33513C12.811 6.44714 12.7665 6.55457 12.6873 6.63377C12.6081 6.71297 12.5007 6.75747 12.3887 6.75747C12.2767 6.75747 12.1692 6.71297 12.09 6.63377C12.0108 6.55457 11.9663 6.44714 11.9663 6.33513V5.0681H10.6993C10.5873 5.0681 10.4799 5.02361 10.4007 4.9444C10.3215 4.8652 10.277 4.75777 10.277 4.64576C10.277 4.53375 10.3215 4.42632 10.4007 4.34712C10.4799 4.26792 10.5873 4.22342 10.6993 4.22342H11.9663V2.95639C11.9663 2.84438 12.0108 2.73696 12.09 2.65775C12.1692 2.57855 12.2767 2.53405 12.3887 2.53405C12.5007 2.53405 12.6081 2.57855 12.6873 2.65775C12.7665 2.73696 12.811 2.84438 12.811 2.95639V4.22342H14.078C14.1901 4.22342 14.2975 4.26792 14.3767 4.34712C14.4559 4.42632 14.5004 4.53375 14.5004 4.64576C14.5004 4.75777 14.4559 4.8652 14.3767 4.9444C14.2975 5.02361 14.1901 5.0681 14.078 5.0681H12.811V6.33513Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.0673 5.42004C20.143 5.42004 18.583 6.98007 18.583 8.90436C18.583 10.8287 20.143 12.3887 22.0673 12.3887C23.9916 12.3887 25.5516 10.8287 25.5516 8.90436C25.5516 6.98007 23.9916 5.42004 22.0673 5.42004ZM22.3841 10.1714C22.3841 10.2554 22.3507 10.336 22.2913 10.3954C22.2319 10.4548 22.1513 10.4881 22.0673 10.4881C21.9833 10.4881 21.9028 10.4548 21.8433 10.3954C21.7839 10.336 21.7506 10.2554 21.7506 10.1714V9.22112H20.8003C20.7163 9.22112 20.6357 9.18775 20.5763 9.12835C20.5169 9.06894 20.4835 8.98837 20.4835 8.90436C20.4835 8.82036 20.5169 8.73979 20.5763 8.68038C20.6357 8.62098 20.7163 8.58761 20.8003 8.58761H21.7506V7.63734C21.7506 7.55333 21.7839 7.47276 21.8433 7.41336C21.9028 7.35396 21.9833 7.32058 22.0673 7.32058C22.1513 7.32058 22.2319 7.35396 22.2913 7.41336C22.3507 7.47276 22.3841 7.55333 22.3841 7.63734V8.58761H23.3344C23.4184 8.58761 23.4989 8.62098 23.5583 8.68038C23.6177 8.73979 23.6511 8.82036 23.6511 8.90436C23.6511 8.98837 23.6177 9.06894 23.5583 9.12835C23.4989 9.18775 23.4184 9.22112 23.3344 9.22112H22.3841V10.1714Z"
				fill={color}
			/>
		</svg>
	);
};

export const TimerIcon = (color = "current") => {
	return (
		<svg
			width="22"
			height="24"
			viewBox="0 0 22 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.4615 3.07692C13.2361 3.07692 15.897 4.17912 17.859 6.14104C19.8209 8.10296 20.9231 10.7639 20.9231 13.5385C20.9231 16.313 19.8209 18.974 17.859 20.9359C15.897 22.8978 13.2361 24 10.4615 24C7.68697 24 5.02603 22.8978 3.06411 20.9359C1.10219 18.974 0 16.313 0 13.5385C0 10.7639 1.10219 8.10296 3.06411 6.14104C5.02603 4.17912 7.68697 3.07692 10.4615 3.07692V3.07692ZM10.4615 4.92308C8.1766 4.92308 5.98524 5.83077 4.36954 7.44647C2.75384 9.06216 1.84615 11.2535 1.84615 13.5385C1.84615 15.8234 2.75384 18.0148 4.36954 19.6305C5.98524 21.2462 8.1766 22.1538 10.4615 22.1538C12.7465 22.1538 14.9378 21.2462 16.5535 19.6305C18.1692 18.0148 19.0769 15.8234 19.0769 13.5385C19.0769 11.2535 18.1692 9.06216 16.5535 7.44647C14.9378 5.83077 12.7465 4.92308 10.4615 4.92308V4.92308ZM10.4615 6.76923C10.6846 6.76924 10.9001 6.85002 11.0682 6.99664C11.2363 7.14325 11.3457 7.34578 11.376 7.56677L11.3846 7.69231V13.2308C11.3845 13.4646 11.2957 13.6898 11.136 13.8607C10.9764 14.0316 10.7578 14.1355 10.5245 14.1514C10.2911 14.1674 10.0604 14.0941 9.87902 13.9465C9.69759 13.799 9.57896 13.588 9.54708 13.3563L9.53846 13.2308V7.69231C9.53846 7.44749 9.63571 7.2127 9.80882 7.03959C9.98193 6.86648 10.2167 6.76923 10.4615 6.76923V6.76923ZM19.2578 3.21723L19.36 3.29108L20.7852 4.47754C20.9637 4.62763 21.0787 4.83969 21.1072 5.07112C21.1358 5.30256 21.0756 5.5362 20.9389 5.72512C20.8022 5.91403 20.5991 6.0442 20.3704 6.08949C20.1416 6.13477 19.9042 6.09181 19.7058 5.96923L19.6049 5.89538L18.1785 4.70892C18 4.55884 17.885 4.34677 17.8564 4.11534C17.8279 3.88391 17.8881 3.65026 18.0248 3.46135C18.1615 3.27243 18.3646 3.14226 18.5933 3.09697C18.8221 3.05169 19.0595 3.09465 19.2578 3.21723V3.21723ZM13.2308 0C13.4646 7.16832e-05 13.6898 0.0889164 13.8607 0.248582C14.0316 0.408247 14.1355 0.626829 14.1514 0.86016C14.1674 1.09349 14.0941 1.32417 13.9465 1.5056C13.799 1.68702 13.588 1.80566 13.3563 1.83754L13.2308 1.84615H7.69231C7.45843 1.84608 7.2333 1.75724 7.06241 1.59757C6.89152 1.43791 6.7876 1.21933 6.77166 0.985994C6.75572 0.752663 6.82894 0.521979 6.97653 0.340555C7.12412 0.159131 7.33508 0.040494 7.56677 0.00861535L7.69231 0H13.2308Z"
				fill={color}
			/>
		</svg>
	);
};

export const ApprovalIcon = (color = "current") => {
	return (
		<svg
			width="24"
			height="25.5"
			viewBox="0 0 24.341669 25.929168"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g transform="translate(292.65667,484.77776)">
				<path
					clipRule="evenodd"
					fill={color}
					fillRule="evenodd"
					strokeWidth="0.5"
					d="m -276.09024,-475.18634 c -0.13156,0 -0.26131,0.0257 -0.38281,0.0762 -0.12143,0.0504 -0.23326,0.1255 -0.32617,0.21875 l -3.79102,3.79297 -1.54296,-1.54297 c -0.0929,-0.0929 -0.20291,-0.16647 -0.32422,-0.2168 v -0.002 c -0.12129,-0.0501 -0.25124,-0.0762 -0.38282,-0.0762 -0.13156,0 -0.26152,0.0279 -0.38281,0.0781 -0.12131,0.0503 -0.23127,0.12389 -0.32422,0.2168 -0.093,0.093 -0.1665,0.20278 -0.21679,0.32422 -0.0503,0.12145 -0.0781,0.25137 -0.0781,0.38281 0,0.13144 0.0278,0.26135 0.0781,0.38281 0.0503,0.12144 0.12381,0.23127 0.21679,0.32422 l 2.24805,2.25 c 0.0928,0.0931 0.20459,0.1683 0.32617,0.21875 0.12157,0.0504 0.25135,0.0762 0.38281,0.0762 0.1314,0 0.26124,-0.0257 0.38282,-0.0762 0.12158,-0.0505 0.23139,-0.12579 0.32422,-0.21875 l 4.5,-4.5 c 0.093,-0.0928 0.16833,-0.20259 0.21874,-0.32422 0.0504,-0.12141 0.0762,-0.25122 0.0762,-0.38281 0,-0.1316 -0.0258,-0.26139 -0.0762,-0.38281 -0.0504,-0.12149 -0.1257,-0.23135 -0.21874,-0.32422 -0.0929,-0.0931 -0.20279,-0.16835 -0.32422,-0.21875 -0.1215,-0.0504 -0.25132,-0.0762 -0.38282,-0.0762 z"
				/>
				<path
					fill={color}
					strokeWidth="0.5"
					d="m -287.34024,-484.18439 c -0.86185,0 -1.6894,0.34175 -2.29882,0.95117 -0.60943,0.60943 -0.95118,1.43697 -0.95118,2.29883 v 1.75 h 2 v -1.75 c 0,-0.33161 0.13076,-0.65028 0.36524,-0.88477 0.23448,-0.23448 0.55315,-0.36523 0.88476,-0.36523 h 15 c 0.33159,0 0.6503,0.13076 0.88477,0.36523 0.23447,0.23448 0.36523,0.55314 0.36523,0.88477 v 18 c 0,0.3316 -0.13077,0.6503 -0.36523,0.88476 -0.23446,0.23447 -0.55316,0.36524 -0.88477,0.36524 h -15 c -0.33162,0 -0.65029,-0.13076 -0.88476,-0.36524 -0.23447,-0.23447 -0.36524,-0.55318 -0.36524,-0.88476 v -1.75 h -2 v 1.75 c 0,0.86181 0.34174,1.68941 0.95118,2.29883 0.60942,0.60941 1.43696,0.95117 2.29882,0.95117 h 15 c 0.86182,0 1.68941,-0.34176 2.29883,-0.95117 0.60942,-0.60942 0.95117,-1.43701 0.95117,-2.29883 v -18 c 0,-0.86186 -0.34176,-1.68941 -0.95117,-2.29883 -0.60942,-0.60943 -1.43702,-0.95117 -2.29883,-0.95117 z"
				/>
				<path
					fill={color}
					strokeWidth="0.5"
					d="m -289.59024,-469.18439 c -0.2651,0 -0.51955,0.10542 -0.70703,0.29297 -0.18751,0.18745 -0.29297,0.44191 -0.29297,0.70703 v 0.5 h -0.5 c -0.2651,0 -0.51955,0.10542 -0.70703,0.29297 -0.18752,0.18745 -0.29297,0.44192 -0.29297,0.70703 0,0.26511 0.10545,0.51958 0.29297,0.70703 0.18748,0.18754 0.44193,0.29297 0.70703,0.29297 h 3 c 0.26511,0 0.51956,-0.10542 0.70704,-0.29297 0.18751,-0.18745 0.29296,-0.44192 0.29296,-0.70703 0,-0.26512 -0.10545,-0.51958 -0.29296,-0.70703 -0.18748,-0.18755 -0.44193,-0.29297 -0.70704,-0.29297 h -0.5 v -0.5 c 0,-0.26512 -0.10545,-0.51958 -0.29296,-0.70703 -0.18748,-0.18755 -0.44193,-0.29297 -0.70704,-0.29297 z"
				/>
				<path
					fill={color}
					strokeWidth="0.5"
					d="m -289.59024,-473.68439 c -0.2651,0 -0.51955,0.10542 -0.70703,0.29297 -0.18751,0.18745 -0.29297,0.44191 -0.29297,0.70703 v 0.5 h -0.5 c -0.2651,0 -0.51955,0.10542 -0.70703,0.29297 -0.18752,0.18745 -0.29297,0.44192 -0.29297,0.70703 0,0.26511 0.10545,0.51958 0.29297,0.70703 0.18748,0.18754 0.44193,0.29297 0.70703,0.29297 h 3 c 0.26511,0 0.51956,-0.10542 0.70704,-0.29297 0.18751,-0.18745 0.29296,-0.44192 0.29296,-0.70703 0,-0.26512 -0.10545,-0.51958 -0.29296,-0.70703 -0.18748,-0.18755 -0.44193,-0.29297 -0.70704,-0.29297 h -0.5 v -0.5 c 0,-0.26512 -0.10545,-0.51958 -0.29296,-0.70703 -0.18748,-0.18755 -0.44193,-0.29297 -0.70704,-0.29297 z"
				/>
				<path
					fill={color}
					strokeWidth="0.5"
					d="m -289.59024,-478.18439 c -0.26512,0 -0.51956,0.1055 -0.70703,0.29297 -0.18747,0.18747 -0.29297,0.44191 -0.29297,0.70703 v 0.5 h -0.5 c -0.26512,0 -0.51956,0.1055 -0.70703,0.29297 -0.18747,0.18747 -0.29297,0.44191 -0.29297,0.70703 0,0.26512 0.1055,0.51956 0.29297,0.70703 0.18747,0.18746 0.44191,0.29297 0.70703,0.29297 h 3 c 0.26512,0 0.51957,-0.1055 0.70704,-0.29297 0.18746,-0.18747 0.29296,-0.44191 0.29296,-0.70703 0,-0.26512 -0.1055,-0.51956 -0.29296,-0.70703 -0.18747,-0.18747 -0.44192,-0.29297 -0.70704,-0.29297 h -0.5 v -0.5 c 0,-0.26512 -0.1055,-0.51956 -0.29296,-0.70703 -0.18747,-0.18747 -0.44192,-0.29297 -0.70704,-0.29297 z"
				/>
			</g>
		</svg>
	);
};

export const MailIcon = (color = "current") => {
	return (
		<svg
			width="19"
			height="15"
			viewBox="0 0 19 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M 3.0253906,0.25 C 1.722551,0.25 0.65039063,1.3221604 0.65039062,2.625 v 9.75 c 0,1.302867 1.07218838,2.375 2.37499998,2.375 H 16.025391 c 1.302784,0 2.375,-1.072105 2.375,-2.375 v -9.75 c 0,-1.3028676 -1.072188,-2.375 -2.375,-2.375 z m 0,1.5 H 16.025391 c 0.484585,0 0.875,0.3903694 0.875,0.875 v 9.75 c 0,0.484704 -0.390387,0.875 -0.875,0.875 H 3.0253906 c -0.4846866,0 -0.875,-0.390269 -0.875,-0.875 v -9.75 c 0,-0.4846586 0.3903414,-0.875 0.875,-0.875 z"
			/>
			<path
				fill={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="M 1.2695312,1.8867187 A 0.75,0.75 0 0 0 0.78515625,2.1953125 0.75,0.75 0 0 0 0.97070313,3.2402344 l 8.12499997,5.6875 a 0.750075,0.750075 0 0 0 0.859375,0 l 8.1249999,-5.6875 A 0.75,0.75 0 0 0 18.265625,2.1953125 0.75,0.75 0 0 0 17.220703,2.0097656 L 9.5253906,7.3964844 1.8300781,2.0097656 A 0.75,0.75 0 0 0 1.2695312,1.8867187 Z"
			/>
		</svg>
	);
};

export const DeleteIcon = (color = "current") => {
	return (
		<svg
			width="15"
			height="16"
			viewBox="0 0 15 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M1.6 14.4C1.6 14.8243 1.76857 15.2313 2.06863 15.5314C2.36869 15.8314 2.77565 16 3.2 16H11.2C11.6243 16 12.0313 15.8314 12.3314 15.5314C12.6314 15.2313 12.8 14.8243 12.8 14.4V4.8H14.4V3.2H11.2V1.6C11.2 1.17565 11.0314 0.768687 10.7314 0.468629C10.4313 0.168571 10.0243 0 9.6 0H4.8C4.37565 0 3.96869 0.168571 3.66863 0.468629C3.36857 0.768687 3.2 1.17565 3.2 1.6V3.2H0V4.8H1.6V14.4ZM4.8 1.6H9.6V3.2H4.8V1.6ZM4 4.8H11.2V14.4H3.2V4.8H4Z"
				fill={color}
			/>
			<path
				d="M4.80029 6.40002H6.40029V12.8H4.80029V6.40002ZM8.00029 6.40002H9.60029V12.8H8.00029V6.40002Z"
				fill={color}
			/>
		</svg>
	);
};

export const EditIcon = (color = "current") => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 18 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m 9.0996094,14.25 a 0.75,0.75 0 0 0 -0.75,0.75 0.75,0.75 0 0 0 0.75,0.75 h 7.4999996 a 0.75,0.75 0 0 0 0.75,-0.75 0.75,0.75 0 0 0 -0.75,-0.75 z"
			/>
			<path
				fill={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m 14.099609,0.25 c -0.663712,0 -1.302099,0.2582168 -1.77539,0.72265625 L 1.9082031,11.193359 a 0.750075,0.750075 0 0 0 -0.2011719,0.351563 l -0.83398432,3.269531 a 0.750075,0.750075 0 0 0 0.90429682,0.914063 l 3.3339844,-0.81836 A 0.750075,0.750075 0 0 0 5.4589844,14.716797 L 15.875,4.4960937 C 16.109233,4.2661854 16.296128,3.9920929 16.423828,3.6894531 16.551341,3.3872564 16.617187,3.0626959 16.617187,2.734375 16.617188,2.4060541 16.551341,2.0814936 16.423828,1.7792969 16.296128,1.4766571 16.109233,1.2025646 15.875,0.97265625 15.640657,0.7427801 15.36318,0.56127971 15.058594,0.4375 14.754096,0.31375604 14.42837,0.25 14.099609,0.25 Z m 0,1.5 c 0.135439,0 0.27003,0.025576 0.394532,0.076172 0.124413,0.05056 0.236021,0.1245333 0.330078,0.2167969 0.09397,0.092231 0.166897,0.2020527 0.216797,0.3203125 0.05009,0.1187028 0.07617,0.243835 0.07617,0.3710937 0,0.1272587 -0.02609,0.254344 -0.07617,0.3730469 -0.0499,0.1182598 -0.122831,0.226128 -0.216797,0.3183594 L 4.5546875,13.501953 2.6347656,13.972656 3.1074219,12.117188 13.375,2.0429688 C 13.564708,1.8568088 13.825722,1.75 14.099609,1.75 Z"
			/>
		</svg>
	);
};

export const EditIconDisabled = (color = "current") => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 18 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m 9.0996094,14.25 a 0.75,0.75 0 0 0 -0.75,0.75 0.75,0.75 0 0 0 0.75,0.75 h 7.4999996 a 0.75,0.75 0 0 0 0.75,-0.75 0.75,0.75 0 0 0 -0.75,-0.75 z"
			/>
			<path
				fill={color}
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m 14.099609,0.25 c -0.663712,0 -1.302099,0.2582168 -1.77539,0.72265625 L 1.9082031,11.193359 a 0.750075,0.750075 0 0 0 -0.2011719,0.351563 l -0.83398432,3.269531 a 0.750075,0.750075 0 0 0 0.90429682,0.914063 l 3.3339844,-0.81836 A 0.750075,0.750075 0 0 0 5.4589844,14.716797 L 15.875,4.4960937 C 16.109233,4.2661854 16.296128,3.9920929 16.423828,3.6894531 16.551341,3.3872564 16.617187,3.0626959 16.617187,2.734375 16.617188,2.4060541 16.551341,2.0814936 16.423828,1.7792969 16.296128,1.4766571 16.109233,1.2025646 15.875,0.97265625 15.640657,0.7427801 15.36318,0.56127971 15.058594,0.4375 14.754096,0.31375604 14.42837,0.25 14.099609,0.25 Z m 0,1.5 c 0.135439,0 0.27003,0.025576 0.394532,0.076172 0.124413,0.05056 0.236021,0.1245333 0.330078,0.2167969 0.09397,0.092231 0.166897,0.2020527 0.216797,0.3203125 0.05009,0.1187028 0.07617,0.243835 0.07617,0.3710937 0,0.1272587 -0.02609,0.254344 -0.07617,0.3730469 -0.0499,0.1182598 -0.122831,0.226128 -0.216797,0.3183594 L 4.5546875,13.501953 2.6347656,13.972656 3.1074219,12.117188 13.375,2.0429688 C 13.564708,1.8568088 13.825722,1.75 14.099609,1.75 Z"
			/>
		</svg>
	);
};

export const ClockIcon = (color = "current") => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.0001 18.3334C14.6025 18.3334 18.3334 14.6025 18.3334 10.0001C18.3334 5.39771 14.6025 1.66675 10.0001 1.66675C5.39771 1.66675 1.66675 5.39771 1.66675 10.0001C1.66675 14.6025 5.39771 18.3334 10.0001 18.3334Z"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 5V10L13.3333 11.6667"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const ListIcon = (color = "current") => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.66675 5H17.5001"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66675 10H17.5001"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M6.66675 15H17.5001"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 5H2.50833"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 10H2.50833"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.5 15H2.50833"
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const StopIcon = (color = "current") => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="16" height="16" rx="4" fill={color} />
		</svg>
	);
};

export const PlayIcon = (color = "current") => {
	return (
		<svg
			width="14"
			height="16"
			viewBox="0 0 14 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.2923 9.23843L2.15764 15.8011C1.21269 16.3574 0 15.6838 0 14.5621V1.43686C0 0.317019 1.21094 -0.358442 2.15764 0.199702L13.2923 6.76234C13.5073 6.88698 13.686 7.06716 13.8103 7.28459C13.9345 7.50202 14 7.74897 14 8.00039C14 8.25181 13.9345 8.49875 13.8103 8.71618C13.686 8.93361 13.5073 9.11379 13.2923 9.23843Z"
				fill={color}
			/>
		</svg>
	);
};

export const PlusIcon = (color = "current") => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.19604 2V14"
				stroke={color}
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2.15698 8H14.2354"
				stroke={color}
				strokeWidth="2.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const DateFilterIcon = (color = "current") => {
	return (
		<svg
			width="18"
			height="20"
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 18V4C18 2.897 17.103 2 16 2H14V0H12V2H6V0H4V2H2C0.897 2 0 2.897 0 4V18C0 19.103 0.897 20 2 20H16C17.103 20 18 19.103 18 18ZM6 16H4V14H6V16ZM6 12H4V10H6V12ZM10 16H8V14H10V16ZM10 12H8V10H10V12ZM14 16H12V14H14V16ZM14 12H12V10H14V12ZM16 7H2V5H16V7Z"
				fill={color}
			/>
		</svg>
	);
};

export const DateTimeIcon = (color = "current") => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10.6665 1.33325V3.99992"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5.3335 1.33325V3.99992"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 6.66675H14"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const PDFFileIcon = (color = "current") => {
	return (
		<svg
			width="18"
			height="20"
			viewBox="0 0 18 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.50293 11.002C4.37032 11.002 4.24314 11.0546 4.14938 11.1484C4.05561 11.2422 4.00293 11.3693 4.00293 11.502V14.502C4.00293 14.6346 4.05561 14.7617 4.14938 14.8555C4.24314 14.9493 4.37032 15.002 4.50293 15.002C4.63554 15.002 4.76272 14.9493 4.85648 14.8555C4.95025 14.7617 5.00293 14.6346 5.00293 14.502V14.002H5.49993C5.89775 14.002 6.27929 13.8439 6.56059 13.5626C6.84189 13.2813 6.99993 12.8998 6.99993 12.502C6.99993 12.1041 6.84189 11.7226 6.56059 11.4413C6.27929 11.16 5.89775 11.002 5.49993 11.002H4.50293ZM5.49993 13.002H5.00293V12.002H5.49993C5.63254 12.002 5.75972 12.0546 5.85348 12.1484C5.94725 12.2422 5.99993 12.3693 5.99993 12.502C5.99993 12.6346 5.94725 12.7617 5.85348 12.8555C5.75972 12.9493 5.63254 13.002 5.49993 13.002Z"
				fill={color}
			/>
			<path
				d="M11.9981 11.501C11.9984 11.3685 12.0512 11.2416 12.1449 11.148C12.2387 11.0545 12.3657 11.002 12.4981 11.002H14.0031C14.1357 11.002 14.2629 11.0546 14.3567 11.1484C14.4504 11.2422 14.5031 11.3693 14.5031 11.502C14.5031 11.6346 14.4504 11.7617 14.3567 11.8555C14.2629 11.9493 14.1357 12.002 14.0031 12.002H12.9971L12.9961 13.004H14.0031C14.1357 13.004 14.2629 13.0566 14.3567 13.1504C14.4504 13.2442 14.5031 13.3713 14.5031 13.504C14.5031 13.6366 14.4504 13.7637 14.3567 13.8575C14.2629 13.9513 14.1357 14.004 14.0031 14.004H12.9961L12.9981 14.501C12.9982 14.5666 12.9854 14.6317 12.9604 14.6924C12.9354 14.7531 12.8987 14.8083 12.8524 14.8548C12.7588 14.9488 12.6317 15.0017 12.4991 15.002C12.3665 15.0022 12.2392 14.9498 12.1453 14.8562C12.0513 14.7626 11.9984 14.6356 11.9981 14.503L11.9951 13.505V13.503L11.9981 11.501Z"
				fill={color}
			/>
			<path
				d="M8.5 11.002C8.36739 11.002 8.24021 11.0546 8.14645 11.1484C8.05268 11.2422 8 11.3693 8 11.502V14.502C8 14.6346 8.05268 14.7617 8.14645 14.8555C8.24021 14.9493 8.36739 15.002 8.5 15.002H8.998C9.52843 15.002 10.0371 14.7912 10.4122 14.4162C10.7873 14.0411 10.998 13.5324 10.998 13.002C10.998 12.4715 10.7873 11.9628 10.4122 11.5877C10.0371 11.2127 9.52843 11.002 8.998 11.002H8.5ZM9 14.002V12.002C9.26522 12.002 9.51957 12.1073 9.70711 12.2948C9.89464 12.4824 10 12.7367 10 13.002C10 13.2672 9.89464 13.5215 9.70711 13.7091C9.51957 13.8966 9.26522 14.002 9 14.002Z"
				fill={color}
			/>
			<path
				d="M17 18V16.836C17.591 16.555 18 15.952 18 15.254V10.75C18 10.052 17.591 9.45 17 9.168V7.828C16.9999 7.29761 16.7891 6.78899 16.414 6.414L10.585 0.586C10.5695 0.571627 10.5532 0.558266 10.536 0.546C10.5236 0.53645 10.5116 0.526443 10.5 0.516C10.4312 0.451071 10.358 0.39093 10.281 0.336C10.2554 0.319482 10.2287 0.304779 10.201 0.292L10.153 0.268L10.103 0.239C10.049 0.208 9.994 0.176 9.937 0.152C9.73786 0.0724632 9.52711 0.0258544 9.313 0.0139999C9.293 0.0129999 9.273 0.00999997 9.254 0.00699997C9.22686 0.00280811 9.19946 0.000469395 9.172 0H3C2.46957 0 1.96086 0.210714 1.58579 0.585786C1.21071 0.960859 1 1.46957 1 2V9.168C0.409 9.449 0 10.052 0 10.75V15.254C0 15.952 0.409 16.554 1 16.836V18C1 18.5304 1.21071 19.0391 1.58579 19.4142C1.96086 19.7893 2.46957 20 3 20H15C15.5304 20 16.0391 19.7893 16.4142 19.4142C16.7893 19.0391 17 18.5304 17 18ZM15 18.5H3C2.86739 18.5 2.74021 18.4473 2.64645 18.3536C2.55268 18.2598 2.5 18.1326 2.5 18V17.004H15.5V18C15.5 18.1326 15.4473 18.2598 15.3536 18.3536C15.2598 18.4473 15.1326 18.5 15 18.5ZM15.5 8V9H2.5V2C2.5 1.86739 2.55268 1.74021 2.64645 1.64645C2.74021 1.55268 2.86739 1.5 3 1.5H9V6C9 6.53043 9.21071 7.03914 9.58579 7.41421C9.96086 7.78929 10.4696 8 11 8H15.5ZM14.378 6.5H11C10.8674 6.5 10.7402 6.44732 10.6464 6.35355C10.5527 6.25979 10.5 6.13261 10.5 6V2.621L14.378 6.5ZM1.75 10.5H16.25C16.3163 10.5 16.3799 10.5263 16.4268 10.5732C16.4737 10.6201 16.5 10.6837 16.5 10.75V15.254C16.5 15.3203 16.4737 15.3839 16.4268 15.4308C16.3799 15.4777 16.3163 15.504 16.25 15.504H1.75C1.6837 15.504 1.62011 15.4777 1.57322 15.4308C1.52634 15.3839 1.5 15.3203 1.5 15.254V10.75C1.5 10.6837 1.52634 10.6201 1.57322 10.5732C1.62011 10.5263 1.6837 10.5 1.75 10.5Z"
				fill={color}
			/>
		</svg>
	);
};

export const GoToLastIcon = (color = "current") => {
	return (
		<svg
			width="12"
			height="13"
			viewBox="0 0 12 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8928 11.6429L5.67847 6.42864L10.8928 1.21436"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 12L1 1"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const NextIcon = (color = "current") => {
	return (
		<svg
			width="7"
			height="13"
			viewBox="0 0 7 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.21429 11.4286L1 6.21429L6.21429 1"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export const UsersIcon = (color = "current") => {
	return (
		<svg
			width="27"
			height="20"
			viewBox="0 0 27 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.18671 8.67481C5.65993 8.67481 6.85769 7.47704 6.85769 6.00383C6.85769 4.53061 5.65993 3.33285 4.18671 3.33285C2.7135 3.33285 1.51573 4.53061 1.51573 6.00383C1.51573 7.47704 2.7135 8.67481 4.18671 8.67481ZM22.8836 8.67481C24.3568 8.67481 25.5546 7.47704 25.5546 6.00383C25.5546 4.53061 24.3568 3.33285 22.8836 3.33285C21.4104 3.33285 20.2126 4.53061 20.2126 6.00383C20.2126 7.47704 21.4104 8.67481 22.8836 8.67481ZM24.2191 10.0103H21.5481C20.8136 10.0103 20.15 10.3067 19.6659 10.7866C21.3477 11.7088 22.5414 13.3741 22.8001 15.3523H25.5546C26.2933 15.3523 26.89 14.7555 26.89 14.0167V12.6813C26.89 11.2081 25.6923 10.0103 24.2191 10.0103ZM13.5351 10.0103C16.1185 10.0103 18.2094 7.91942 18.2094 5.33609C18.2094 2.75274 16.1185 0.661865 13.5351 0.661865C10.9518 0.661865 8.86093 2.75274 8.86093 5.33609C8.86093 7.91942 10.9518 10.0103 13.5351 10.0103ZM16.7403 11.3457H16.3939C15.5258 11.7631 14.5618 12.0136 13.5351 12.0136C12.5085 12.0136 11.5486 11.7631 10.6764 11.3457H10.3299C7.67568 11.3457 5.5222 13.4993 5.5222 16.1536V17.3555C5.5222 18.4615 6.41948 19.3587 7.52543 19.3587H19.5448C20.6508 19.3587 21.5481 18.4615 21.5481 17.3555V16.1536C21.5481 13.4993 19.3947 11.3457 16.7403 11.3457ZM7.40441 10.7866C6.92029 10.3067 6.25672 10.0103 5.5222 10.0103H2.85122C1.37801 10.0103 0.180237 11.2081 0.180237 12.6813V14.0167C0.180237 14.7555 0.777034 15.3523 1.51573 15.3523H4.26601C4.52893 13.3741 5.72253 11.7088 7.40441 10.7866Z"
				fill={color}
			/>
		</svg>
	);
};

export const HomeIcon = (color = "current") => {
	return (
		<svg
			width="22"
			height="20"
			viewBox="0 0 22 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.7436 9.83614L11.1195 0.21903C11.0502 0.149598 10.9679 0.0945134 10.8773 0.0569295C10.7867 0.0193456 10.6895 0 10.5914 0C10.4933 0 10.3962 0.0193456 10.3056 0.0569295C10.215 0.0945134 10.1327 0.149598 10.0634 0.21903L0.439266 9.83614C0.158883 10.1165 0 10.4974 0 10.8946C0 11.7194 0.670581 12.39 1.49537 12.39H2.50942V19.2523C2.50942 19.6659 2.84354 20 3.25711 20H9.09607V14.7662H11.713V20H17.9258C18.3393 20 18.6735 19.6659 18.6735 19.2523V12.39H19.6875C20.0847 12.39 20.4656 12.2334 20.746 11.9507C21.3277 11.3666 21.3277 10.4203 20.7436 9.83614Z"
				fill={color}
			/>
		</svg>
	);
};

export const LogsIcon = (color = "current") => {
	return (
		<svg
			width="16"
			height="20"
			viewBox="0 0 16 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.74 5.33L11.3 0.329997C11.2065 0.226404 11.0924 0.143526 10.9649 0.0866923C10.8375 0.0298583 10.6995 0.0003267 10.56 -3.1293e-06H2.56C2.22775 -0.00396622 1.89797 0.0575569 1.5895 0.181053C1.28103 0.304549 0.999904 0.4876 0.762182 0.719751C0.524459 0.951902 0.334794 1.22861 0.204018 1.53406C0.0732421 1.83952 0.00391638 2.16775 0 2.5V17.5C0.00391638 17.8322 0.0732421 18.1605 0.204018 18.4659C0.334794 18.7714 0.524459 19.0481 0.762182 19.2802C0.999904 19.5124 1.28103 19.6954 1.5895 19.8189C1.89797 19.9424 2.22775 20.004 2.56 20H13.44C13.7723 20.004 14.102 19.9424 14.4105 19.8189C14.719 19.6954 15.0001 19.5124 15.2378 19.2802C15.4755 19.0481 15.6652 18.7714 15.796 18.4659C15.9268 18.1605 15.9961 17.8322 16 17.5V6C15.9994 5.75216 15.9067 5.51339 15.74 5.33ZM5 10H8C8.26522 10 8.51957 10.1054 8.70711 10.2929C8.89464 10.4804 9 10.7348 9 11C9 11.2652 8.89464 11.5196 8.70711 11.7071C8.51957 11.8946 8.26522 12 8 12H5C4.73478 12 4.48043 11.8946 4.29289 11.7071C4.10536 11.5196 4 11.2652 4 11C4 10.7348 4.10536 10.4804 4.29289 10.2929C4.48043 10.1054 4.73478 10 5 10ZM11 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15C4 14.7348 4.10536 14.4804 4.29289 14.2929C4.48043 14.1054 4.73478 14 5 14H11C11.2652 14 11.5196 14.1054 11.7071 14.2929C11.8946 14.4804 12 14.7348 12 15C12 15.2652 11.8946 15.5196 11.7071 15.7071C11.5196 15.8946 11.2652 16 11 16ZM10.71 6C10.5038 5.9797 10.3139 5.87923 10.1811 5.72025C10.0483 5.56126 9.98327 5.35647 10 5.15V2L13.74 6H10.71Z"
				fill={color}
			/>
		</svg>
	);
};

export const WarningIcon = color => {
	return (
		<svg
			width="23"
			height="20"
			viewBox="0 0 23 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.5407 14.962L14.5171 1.65558C14.1927 1.14803 13.7457 0.730331 13.2173 0.440995C12.689 0.151659 12.0963 0 11.4939 0C10.8915 0 10.2988 0.151659 9.77048 0.440995C9.24213 0.730331 8.79513 1.14803 8.47069 1.65558L0.447108 14.962C0.163671 15.4344 0.00961747 15.9732 0.000435888 16.5241C-0.00874569 17.075 0.127268 17.6186 0.394803 18.1003C0.704113 18.6424 1.15182 19.0927 1.69218 19.4052C2.23253 19.7176 2.84615 19.881 3.47033 19.8786H19.5175C20.1376 19.8852 20.7484 19.7282 21.2884 19.4233C21.8284 19.1184 22.2784 18.6765 22.593 18.1421C22.8684 17.6554 23.0088 17.104 22.9996 16.5449C22.9904 15.9858 22.832 15.4393 22.5407 14.962ZM11.4939 15.6942C11.287 15.6942 11.0848 15.6329 10.9127 15.5179C10.7407 15.403 10.6066 15.2396 10.5274 15.0485C10.4483 14.8573 10.4276 14.647 10.4679 14.444C10.5083 14.2411 10.6079 14.0547 10.7542 13.9084C10.9005 13.7621 11.0869 13.6625 11.2898 13.6221C11.4928 13.5818 11.7031 13.6025 11.8942 13.6817C12.0854 13.7608 12.2488 13.8949 12.3637 14.0669C12.4787 14.239 12.54 14.4412 12.54 14.6481C12.54 14.9256 12.4298 15.1917 12.2336 15.3878C12.0374 15.584 11.7714 15.6942 11.4939 15.6942ZM12.54 11.5098C12.54 11.7873 12.4298 12.0534 12.2336 12.2495C12.0374 12.4457 11.7714 12.5559 11.4939 12.5559C11.2165 12.5559 10.9504 12.4457 10.7542 12.2495C10.558 12.0534 10.4478 11.7873 10.4478 11.5098V7.32544C10.4478 7.04799 10.558 6.78192 10.7542 6.58573C10.9504 6.38955 11.2165 6.27934 11.4939 6.27934C11.7714 6.27934 12.0374 6.38955 12.2336 6.58573C12.4298 6.78192 12.54 7.04799 12.54 7.32544V11.5098Z"
				fill={color}
			/>
		</svg>
	);
};

export const WarningIconDisabled16 = color => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 23 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.5407 14.962L14.5171 1.65558C14.1927 1.14803 13.7457 0.730331 13.2173 0.440995C12.689 0.151659 12.0963 0 11.4939 0C10.8915 0 10.2988 0.151659 9.77048 0.440995C9.24213 0.730331 8.79513 1.14803 8.47069 1.65558L0.447108 14.962C0.163671 15.4344 0.00961747 15.9732 0.000435888 16.5241C-0.00874569 17.075 0.127268 17.6186 0.394803 18.1003C0.704113 18.6424 1.15182 19.0927 1.69218 19.4052C2.23253 19.7176 2.84615 19.881 3.47033 19.8786H19.5175C20.1376 19.8852 20.7484 19.7282 21.2884 19.4233C21.8284 19.1184 22.2784 18.6765 22.593 18.1421C22.8684 17.6554 23.0088 17.104 22.9996 16.5449C22.9904 15.9858 22.832 15.4393 22.5407 14.962ZM11.4939 15.6942C11.287 15.6942 11.0848 15.6329 10.9127 15.5179C10.7407 15.403 10.6066 15.2396 10.5274 15.0485C10.4483 14.8573 10.4276 14.647 10.4679 14.444C10.5083 14.2411 10.6079 14.0547 10.7542 13.9084C10.9005 13.7621 11.0869 13.6625 11.2898 13.6221C11.4928 13.5818 11.7031 13.6025 11.8942 13.6817C12.0854 13.7608 12.2488 13.8949 12.3637 14.0669C12.4787 14.239 12.54 14.4412 12.54 14.6481C12.54 14.9256 12.4298 15.1917 12.2336 15.3878C12.0374 15.584 11.7714 15.6942 11.4939 15.6942ZM12.54 11.5098C12.54 11.7873 12.4298 12.0534 12.2336 12.2495C12.0374 12.4457 11.7714 12.5559 11.4939 12.5559C11.2165 12.5559 10.9504 12.4457 10.7542 12.2495C10.558 12.0534 10.4478 11.7873 10.4478 11.5098V7.32544C10.4478 7.04799 10.558 6.78192 10.7542 6.58573C10.9504 6.38955 11.2165 6.27934 11.4939 6.27934C11.7714 6.27934 12.0374 6.38955 12.2336 6.58573C12.4298 6.78192 12.54 7.04799 12.54 7.32544V11.5098Z"
				fill={"#9a9a9a"}
			/>
		</svg>
	);
};

export const WarningIcon16 = color => {
	return (
		<svg
			width="18"
			height="16"
			viewBox="0 0 23 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.5407 14.962L14.5171 1.65558C14.1927 1.14803 13.7457 0.730331 13.2173 0.440995C12.689 0.151659 12.0963 0 11.4939 0C10.8915 0 10.2988 0.151659 9.77048 0.440995C9.24213 0.730331 8.79513 1.14803 8.47069 1.65558L0.447108 14.962C0.163671 15.4344 0.00961747 15.9732 0.000435888 16.5241C-0.00874569 17.075 0.127268 17.6186 0.394803 18.1003C0.704113 18.6424 1.15182 19.0927 1.69218 19.4052C2.23253 19.7176 2.84615 19.881 3.47033 19.8786H19.5175C20.1376 19.8852 20.7484 19.7282 21.2884 19.4233C21.8284 19.1184 22.2784 18.6765 22.593 18.1421C22.8684 17.6554 23.0088 17.104 22.9996 16.5449C22.9904 15.9858 22.832 15.4393 22.5407 14.962ZM11.4939 15.6942C11.287 15.6942 11.0848 15.6329 10.9127 15.5179C10.7407 15.403 10.6066 15.2396 10.5274 15.0485C10.4483 14.8573 10.4276 14.647 10.4679 14.444C10.5083 14.2411 10.6079 14.0547 10.7542 13.9084C10.9005 13.7621 11.0869 13.6625 11.2898 13.6221C11.4928 13.5818 11.7031 13.6025 11.8942 13.6817C12.0854 13.7608 12.2488 13.8949 12.3637 14.0669C12.4787 14.239 12.54 14.4412 12.54 14.6481C12.54 14.9256 12.4298 15.1917 12.2336 15.3878C12.0374 15.584 11.7714 15.6942 11.4939 15.6942ZM12.54 11.5098C12.54 11.7873 12.4298 12.0534 12.2336 12.2495C12.0374 12.4457 11.7714 12.5559 11.4939 12.5559C11.2165 12.5559 10.9504 12.4457 10.7542 12.2495C10.558 12.0534 10.4478 11.7873 10.4478 11.5098V7.32544C10.4478 7.04799 10.558 6.78192 10.7542 6.58573C10.9504 6.38955 11.2165 6.27934 11.4939 6.27934C11.7714 6.27934 12.0374 6.38955 12.2336 6.58573C12.4298 6.78192 12.54 7.04799 12.54 7.32544V11.5098Z"
				fill={color}
			/>
		</svg>
	);
};

export const LinkIcon = color => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
		>
			<path
				d="M6.188 8.719c.439-.439.926-.801 1.444-1.087 2.887-1.591 6.589-.745 8.445 2.069l-2.246 2.245c-.644-1.469-2.243-2.305-3.834-1.949-.599.134-1.168.433-1.633.898l-4.304 4.306c-1.307 1.307-1.307 3.433 0 4.74 1.307 1.307 3.433 1.307 4.74 0l1.327-1.327c1.207.479 2.501.67 3.779.575l-2.929 2.929c-2.511 2.511-6.582 2.511-9.093 0s-2.511-6.582 0-9.093l4.304-4.306zm6.836-6.836l-2.929 2.929c1.277-.096 2.572.096 3.779.574l1.326-1.326c1.307-1.307 3.433-1.307 4.74 0 1.307 1.307 1.307 3.433 0 4.74l-4.305 4.305c-1.311 1.311-3.44 1.3-4.74 0-.303-.303-.564-.68-.727-1.051l-2.246 2.245c.236.358.481.667.796.982.812.812 1.846 1.417 3.036 1.704 1.542.371 3.194.166 4.613-.617.518-.286 1.005-.648 1.444-1.087l4.304-4.305c2.512-2.511 2.512-6.582.001-9.093-2.511-2.51-6.581-2.51-9.092 0z"
				fill={color}
			/>
		</svg>
	);
};

export const File = color => {
	return (
		<svg
			width="16"
			height="20"
			viewBox="0 0 16 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.3 0.33018L15.74 5.33018C15.9067 5.51358 15.9994 5.75234 16 6.00018V17.5002C15.9961 17.8324 15.9268 18.1607 15.796 18.4661C15.6652 18.7716 15.4755 19.0483 15.2378 19.2804C15.0001 19.5126 14.719 19.6956 14.4105 19.8191C14.102 19.9426 13.7723 20.0041 13.44 20.0002H2.56C2.22775 20.0041 1.89797 19.9426 1.5895 19.8191C1.28103 19.6956 0.999904 19.5126 0.762182 19.2804C0.524459 19.0483 0.334794 18.7716 0.204018 18.4661C0.0732421 18.1607 0.00391638 17.8324 0 17.5002V2.50018C0.00391638 2.16793 0.0732421 1.8397 0.204018 1.53425C0.334794 1.22879 0.524459 0.952085 0.762182 0.719934C0.999904 0.487783 1.28103 0.304732 1.5895 0.181236C1.89797 0.05774 2.22775 -0.00378312 2.56 0.000179976H10.56C10.6995 0.000509805 10.8375 0.0300414 10.9649 0.0868754C11.0924 0.143709 11.2065 0.226587 11.3 0.33018ZM10.1811 5.72043C10.3139 5.87942 10.5038 5.97988 10.71 6.00018H13.74L10 2.00018V5.15018C9.98327 5.35666 10.0483 5.56144 10.1811 5.72043ZM2.26474 8.18696C2.14503 8.30667 2.07777 8.46904 2.07777 8.63833V10.7661C2.07777 10.9354 2.14503 11.0978 2.26474 11.2175C2.38445 11.3372 2.54681 11.4044 2.71611 11.4044H3.14166V13.6939L1.62669 15.2089C1.50715 15.3286 1.44 15.4908 1.44 15.66C1.44 15.8292 1.50715 15.9914 1.62669 16.1111L3.32891 17.8133C3.4486 17.9329 3.61084 18 3.78 18C3.94916 18 4.1114 17.9329 4.23109 17.8133L5.74607 16.2983H8.03556V16.7239C8.03556 16.8932 8.10281 17.0556 8.22252 17.1753C8.34223 17.295 8.50459 17.3622 8.67389 17.3622H10.8017C10.971 17.3622 11.1333 17.295 11.253 17.1753C11.3728 17.0556 11.44 16.8932 11.44 16.7239V14.5961C11.44 14.4268 11.3728 14.2645 11.253 14.1447C11.1333 14.025 10.971 13.9578 10.8017 13.9578H8.67389C8.50459 13.9578 8.34223 14.025 8.22252 14.1447C8.10281 14.2645 8.03556 14.4268 8.03556 14.5961V15.0217H5.74607L4.41833 13.6939V11.4044H4.84389C5.01318 11.4044 5.17555 11.3372 5.29526 11.2175C5.41497 11.0978 5.48222 10.9354 5.48222 10.7661V8.63833C5.48222 8.46904 5.41497 8.30667 5.29526 8.18696C5.17555 8.06725 5.01318 8 4.84389 8H2.71611C2.54681 8 2.38445 8.06725 2.26474 8.18696Z"
				fill={color}
			/>
		</svg>
	);
};

export const SubmenuRightArrow = color => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.00033 0.666656C3.95033 0.666656 0.666992 3.94999 0.666992 7.99999C0.666992 12.05 3.95033 15.3333 8.00033 15.3333C12.0503 15.3333 15.3337 12.05 15.3337 7.99999C15.3337 3.94999 12.0503 0.666656 8.00033 0.666656ZM6.52899 5.80466C6.40755 5.67892 6.34036 5.51052 6.34188 5.33572C6.34339 5.16092 6.41351 4.99372 6.53711 4.87011C6.66072 4.74651 6.82793 4.67639 7.00272 4.67487C7.17752 4.67335 7.34592 4.74055 7.47166 4.86199L10.1383 7.52866C10.2633 7.65367 10.3335 7.82321 10.3335 7.99999C10.3335 8.17677 10.2633 8.3463 10.1383 8.47132L7.47166 11.138C7.34592 11.2594 7.17752 11.3266 7.00272 11.3251C6.82793 11.3236 6.66072 11.2535 6.53711 11.1299C6.41351 11.0063 6.34339 10.8391 6.34188 10.6643C6.34036 10.4895 6.40755 10.3211 6.52899 10.1953L8.72433 7.99999L6.52899 5.80466Z"
				fill={color}
			/>
		</svg>
	);
};

export const apiKeyIcon = color => {
	return (
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g>
				<path
					d="M9.4,29.8c-2.4,0-4.9-0.9-6.7-2.8c-3.7-3.7-3.7-9.8,0-13.5c3.3-3.3,8.5-3.7,12.3-1c0.4,0.3,0.5,1,0.2,1.4c-0.3,0.4-0.9,0.5-1.4,0.2c-3-2.2-7.1-1.9-9.7,0.8c-2.9,2.9-2.9,7.7,0,10.6c2.9,2.9,7.7,2.9,10.6,0c0.1-0.1,0.2-0.2,0.3-0.4c0.4-0.4,1-0.5,1.4-0.1c0.4,0.4,0.5,1,0.1,1.4c-0.1,0.2-0.3,0.3-0.4,0.4C14.2,28.9,11.8,29.8,9.4,29.8z"
					fill={color}
				/>
			</g>
			<g>
				<path
					d="M9.4,24.6c-1.1,0-2.2-0.4-3-1.3c-0.8-0.8-1.3-1.9-1.3-3c0-1.1,0.4-2.2,1.3-3c0.8-0.8,1.9-1.3,3-1.3c1.1,0,2.2,0.4,3,1.3c0.4,0.4,0.4,1,0,1.4c-0.4,0.4-1,0.4-1.4,0c-0.9-0.9-2.4-0.9-3.2,0c-0.4,0.4-0.7,1-0.7,1.6c0,0.6,0.2,1.2,0.7,1.6c0.9,0.9,2.4,0.9,3.2,0c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4C11.6,24.2,10.5,24.6,9.4,24.6z"
					fill={color}
				/>
			</g>
			<g>
				<path
					d="M36,25.8c-1.4,0-2.1-0.8-2.6-1.3c-0.5-0.5-0.7-0.7-1.2-0.7c-0.5,0-0.7,0.2-1.2,0.7c-0.5,0.6-1.2,1.3-2.6,1.3c-1.4,0-2.1-0.8-2.6-1.3c-0.5-0.5-0.7-0.7-1.2-0.7s-0.7,0.2-1.2,0.7c-0.5,0.6-1.2,1.3-2.6,1.3c-1.4,0-2.1-0.8-2.6-1.3c-0.4-0.4-0.6-0.6-0.9-0.7c-0.5-0.1-0.9-0.7-0.8-1.2s0.7-0.9,1.2-0.8c0.9,0.2,1.5,0.8,1.9,1.2c0.5,0.5,0.7,0.7,1.2,0.7c0.5,0,0.7-0.2,1.2-0.7c0.5-0.6,1.2-1.3,2.6-1.3c1.4,0,2.1,0.8,2.6,1.3c0.5,0.5,0.7,0.7,1.2,0.7c0.5,0,0.7-0.2,1.2-0.7c0.5-0.6,1.2-1.3,2.6-1.3c1.4,0,2.1,0.8,2.6,1.3c0.3,0.3,0.5,0.5,0.7,0.6l2.3-3.4l-2.3-3.5H16.6c-0.6,0-1-0.4-1-1s0.4-1,1-1H36c0.3,0,0.6,0.2,0.8,0.4l3,4.5c0.2,0.3,0.2,0.8,0,1.1l-3,4.5C36.6,25.7,36.3,25.8,36,25.8z"
					fill={color}
				/>
			</g>
		</svg>
	);
};

export const SettingsIcon = () => {
	return (
		<svg
			fill="#000000"
			height="30px"
			width="30px"
			version="1.1"
			id="Capa_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 54 54"
		>
			<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
			<g
				id="SVGRepo_tracerCarrier"
				stroke-linecap="round"
				stroke-linejoin="round"
			></g>
			<g id="SVGRepo_iconCarrier">
				<g>
					<path d="M51.22,21h-5.052c-0.812,0-1.481-0.447-1.792-1.197s-0.153-1.54,0.42-2.114l3.572-3.571 c0.525-0.525,0.814-1.224,0.814-1.966c0-0.743-0.289-1.441-0.814-1.967l-4.553-4.553c-1.05-1.05-2.881-1.052-3.933,0l-3.571,3.571 c-0.574,0.573-1.366,0.733-2.114,0.421C33.447,9.313,33,8.644,33,7.832V2.78C33,1.247,31.753,0,30.22,0H23.78 C22.247,0,21,1.247,21,2.78v5.052c0,0.812-0.447,1.481-1.197,1.792c-0.748,0.313-1.54,0.152-2.114-0.421l-3.571-3.571 c-1.052-1.052-2.883-1.05-3.933,0l-4.553,4.553c-0.525,0.525-0.814,1.224-0.814,1.967c0,0.742,0.289,1.44,0.814,1.966l3.572,3.571 c0.573,0.574,0.73,1.364,0.42,2.114S8.644,21,7.832,21H2.78C1.247,21,0,22.247,0,23.78v6.439C0,31.753,1.247,33,2.78,33h5.052 c0.812,0,1.481,0.447,1.792,1.197s0.153,1.54-0.42,2.114l-3.572,3.571c-0.525,0.525-0.814,1.224-0.814,1.966 c0,0.743,0.289,1.441,0.814,1.967l4.553,4.553c1.051,1.051,2.881,1.053,3.933,0l3.571-3.572c0.574-0.573,1.363-0.731,2.114-0.42 c0.75,0.311,1.197,0.98,1.197,1.792v5.052c0,1.533,1.247,2.78,2.78,2.78h6.439c1.533,0,2.78-1.247,2.78-2.78v-5.052 c0-0.812,0.447-1.481,1.197-1.792c0.751-0.312,1.54-0.153,2.114,0.42l3.571,3.572c1.052,1.052,2.883,1.05,3.933,0l4.553-4.553 c0.525-0.525,0.814-1.224,0.814-1.967c0-0.742-0.289-1.44-0.814-1.966l-3.572-3.571c-0.573-0.574-0.73-1.364-0.42-2.114 S45.356,33,46.168,33h5.052c1.533,0,2.78-1.247,2.78-2.78V23.78C54,22.247,52.753,21,51.22,21z M52,30.22 C52,30.65,51.65,31,51.22,31h-5.052c-1.624,0-3.019,0.932-3.64,2.432c-0.622,1.5-0.295,3.146,0.854,4.294l3.572,3.571 c0.305,0.305,0.305,0.8,0,1.104l-4.553,4.553c-0.304,0.304-0.799,0.306-1.104,0l-3.571-3.572c-1.149-1.149-2.794-1.474-4.294-0.854 c-1.5,0.621-2.432,2.016-2.432,3.64v5.052C31,51.65,30.65,52,30.22,52H23.78C23.35,52,23,51.65,23,51.22v-5.052 c0-1.624-0.932-3.019-2.432-3.64c-0.503-0.209-1.021-0.311-1.533-0.311c-1.014,0-1.997,0.4-2.761,1.164l-3.571,3.572 c-0.306,0.306-0.801,0.304-1.104,0l-4.553-4.553c-0.305-0.305-0.305-0.8,0-1.104l3.572-3.571c1.148-1.148,1.476-2.794,0.854-4.294 C10.851,31.932,9.456,31,7.832,31H2.78C2.35,31,2,30.65,2,30.22V23.78C2,23.35,2.35,23,2.78,23h5.052 c1.624,0,3.019-0.932,3.64-2.432c0.622-1.5,0.295-3.146-0.854-4.294l-3.572-3.571c-0.305-0.305-0.305-0.8,0-1.104l4.553-4.553 c0.304-0.305,0.799-0.305,1.104,0l3.571,3.571c1.147,1.147,2.792,1.476,4.294,0.854C22.068,10.851,23,9.456,23,7.832V2.78 C23,2.35,23.35,2,23.78,2h6.439C30.65,2,31,2.35,31,2.78v5.052c0,1.624,0.932,3.019,2.432,3.64 c1.502,0.622,3.146,0.294,4.294-0.854l3.571-3.571c0.306-0.305,0.801-0.305,1.104,0l4.553,4.553c0.305,0.305,0.305,0.8,0,1.104 l-3.572,3.571c-1.148,1.148-1.476,2.794-0.854,4.294c0.621,1.5,2.016,2.432,3.64,2.432h5.052C51.65,23,52,23.35,52,23.78V30.22z"></path>
					<path d="M27,18c-4.963,0-9,4.037-9,9s4.037,9,9,9s9-4.037,9-9S31.963,18,27,18z M27,34c-3.859,0-7-3.141-7-7s3.141-7,7-7 s7,3.141,7,7S30.859,34,27,34z"></path>
				</g>
			</g>
		</svg>
	);
};

export const PromptsIcon = (color = "current") => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
				fill={color}
			/>
			<path
				d="M8 6h4v2H8V6zm0 3h4v2H8V9zm0 3h3v2H8v-2z"
				fill={color}
			/>
		</svg>
	);
};

export const ManagementIcon = (color = "current") => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
				fill="currentColor"
			/>
			<path
				d="M6 6h8v2H6V6zm0 3h8v2H6V9zm0 3h6v2H6v-2z"
				fill="currentColor"
			/>
			<path
				d="M14 12h2v2h-2v-2zm0 3h2v2h-2v-2z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const AccessIcon = (color = "current") => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
				fill="currentColor"
			/>
			<path
				d="M8 6h4v2H8V6zm0 3h4v2H8V9zm0 3h3v2H8v-2z"
				fill="currentColor"
			/>
			<path
				d="M12 12h2v2h-2v-2zm0 3h2v2h-2v-2z"
				fill="currentColor"
			/>
			<path
				d="M6 12h2v2H6v-2zm0 3h2v2H6v-2z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ReportsIcon = (color = "current") => {
	return (
		<svg
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
				fill="currentColor"
			/>
			<path
				d="M6 6h8v2H6V6zm0 3h8v2H6V9zm0 3h6v2H6v-2z"
				fill="currentColor"
			/>
			<path
				d="M14 12h2v2h-2v-2zm0 3h2v2h-2v-2z"
				fill="currentColor"
			/>
			<path
				d="M6 12h2v2H6v-2zm0 3h2v2H6v-2z"
				fill="currentColor"
			/>
		</svg>
	);
};